import AddIcon from '@mui/icons-material/Add';
import { Box, Container, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
import List from "@mui/material/List";
import makeStyles from '@mui/styles/makeStyles';
import * as actions from "actions";
import SearchBar from "components/common/SearchBar";
import { prop } from "ramda";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientListItem from "./ClientListItem";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    position: "relative",
    overflow: "auto",
  },
  ul: {
    padding: 0,
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  item: {
    border: "1px solid rgb(216,216,216)",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "16px",
  },
}));

export default function ClientList({ height, onItemSelect, onAddNewClient }) {
  const classes = useStyles();
  const handleClick = (client) => () => !!onItemSelect && onItemSelect(client);
  const handelNewClientClick = () => !!onAddNewClient && onAddNewClient();


  const dispatch = useDispatch();
  const updateAll = () => {
    dispatch(actions.getClients());
  }

  useEffect(updateAll, []);
  const { clients, scrollPosition } = useSelector(prop('client'));
  const [filteredList, setFilteredList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const onSearch = (e) => {
    setSearchText(e.target.value.trim().toLowerCase());
  }

  useEffect(() => {
    let filterdList = clients ? clients : [];
    if (searchText.length>0) {
     filterdList = filterdList.filter(k=>k.FirstName?.toLowerCase().includes(searchText));
    } 
    setFilteredList(filterdList)
  }, [clients, searchText]);

  const setScrollPosition = () => {
    const table = document.getElementById('table-container-client');
    if (table) {
      table.scrollTop = scrollPosition;
    }
  };

  const handleTableScroll = (event) => {
    const currentPosition = event.target.scrollTop;
    dispatch(actions.setClientProps({ scrollPosition: currentPosition }));
  };
  React.useEffect(() => {
    setScrollPosition();
  }, [filteredList]);
  return (
    <Container id="table-container-client" sx={{ height: 'calc(100vh - 70px)', overflow: 'auto' }}
      onScroll={handleTableScroll}>
      <Box mt={4}>
        <Typography variant="h5" gutterBottom>
          <strong data-testid="label-user-administration">
          Agency/Owner
          </strong>
        </Typography>
        <Typography
          color="textSecondary"
          data-testid="label-user-administration-secondary-text"
        >
          Add as many Agency/Owner as you want.
        </Typography>
      </Box>
      <Box mt={4}>
        <Typography variant="h6" gutterBottom>
          <strong data-testid="label-user-administration-list-user">
            A list of Agency/Owner
          </strong>
        </Typography>
        <SearchBar placeHolder='Type to Search' onChange={onSearch}></SearchBar>

      </Box>
      <List className={classes.root} style={{ height }} dense={false}>
        <ul className={classes.ul}>
        <ListItem
            dense
            disableGutters
            onClick={onAddNewClient}
            className={classes.item}
            data-testid={'li-add-user'}
          >
            <ListItemAvatar>
              <AddIcon />
            </ListItemAvatar>
            <ListItemText
              primary={'Add a Agency/Owner'}
              primaryTypographyProps={{ className: "bold" }}
            />
          </ListItem>
          {filteredList?.map((client) => (
            <ClientListItem
              key={client.Id}
              client={client}
              onClick={handleClick(client)}
              itemClasses={classes.item}
              
            />
          ))}

        
        </ul>
      </List>
    </Container>
  );
}
